import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import rekapLemburService from "../../services/rekapLemburService";
import Cookies from "js-cookie";

export const initialState = {
    loading_rekap_lembur: false,
    data_rekap_lembur: [],
    showMessage:false,
    message:'',
}


export const getDataRekapLembur = createAsyncThunk('lembur/rekap',async (data, { rejectWithValue }) => {
    try {
        const response = await rekapLemburService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const rekapLemburSlice = createSlice({
    name: 'rekap_lembur',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_lembur = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataRekapLembur.fulfilled, (state, action) => {
                state.loading_rekap_lembur = false
                state.data_rekap_lembur = action.payload??[]
            })
            .addCase(getDataRekapLembur.pending, (state) => {
                state.loading_rekap_lembur = true
            })
            .addCase(getDataRekapLembur.rejected, (state, action) => {
                state.loading_rekap_lembur = false
                state.data_rekap_lembur = action.payload
            })
    },
})

export const {
    showLoading,
} = rekapLemburSlice.actions

export default rekapLemburSlice.reducer
